import { useReducer, useState } from "react";
import { Box } from "@mui/material";
import reduceStormOptionsOne, {
 defaultReducedStormOptionsOne,
} from "../../../store/stormOptionsOne";
import reduceStormOptionsTwo, {
 defaultReducedStormOptionsTwo,
} from "../../../store/stormOptionsTwo";
import Sidebar from "../Sidebar/Sidebar";
import MapComponent from "../Maps/Map1/MapComponent";
import MobileAppBar from "../Navigation/MobileAppBar";
import CompareTwoScenariosMapContainer from "../Maps/Map2/CompareTwoScenariosMapContainer";
import "./Pages.css";

const MobileMainPage = () => {
 const [open, setOpen] = useState(false);
 const [mapExtent, setMapExtent] = useState();
 const [mapExtent2, setMapExtent2] = useState();
 const [checked, setChecked] = useState(false);
 const [withAdaptations, setWithAdaptations] = useState(false);
 const [reductionStateOne, setReductionStateOne] = useReducer(
  reduceStormOptionsOne,
  defaultReducedStormOptionsOne
 );
 const [reductionStateTwo, setReductionStateTwo] = useReducer(
  reduceStormOptionsTwo,
  defaultReducedStormOptionsTwo
 );
 const [criticalAssetsEnabled, setCriticalAssetsEnabled] = useState(false);

 const btnClickOne = async (type, value) => {
  setReductionStateOne({ type: type, value: value });
 };

 const btnClickTwo = async (type, value) => {
  setReductionStateTwo({ type: type, value: value });
 };

 return (
  <Box className="main-page-box">
   <MobileAppBar
    open={open}
    withAdaptations={withAdaptations}
    setWithAdaptations={setWithAdaptations}
    checked={checked}
    setChecked={setChecked}
   />

   <Sidebar
    open={open}
    setOpen={setOpen}
    checked={checked}
    setChecked={setChecked}
    withAdaptations={withAdaptations}
    setWithAdaptations={setWithAdaptations}
    btnClickOne={btnClickOne}
    btnClickTwo={btnClickTwo}
    reductionStateOne={reductionStateOne}
    reductionStateTwo={reductionStateTwo}
   />

   <div
    className={
     !!open && !!checked ? "compare-map-row-open-mobile" : "compare-map-row"
    }
   >
    <MapComponent
     open={open}
     checked={checked}
     mapExtent={mapExtent}
     setMapExtent={setMapExtent}
     reductionState={reductionStateOne}
     criticalAssetsEnabled={criticalAssetsEnabled}
     setCriticalAssetsEnabled={setCriticalAssetsEnabled}
    />
    {!!checked && (
     <CompareTwoScenariosMapContainer
      open={open}
      checked={checked}
      mapExtent={mapExtent2}
      setMapExtent={setMapExtent2}
      reductionState={reductionStateTwo}
     />
    )}
   </div>
  </Box>
 );
};

export default MobileMainPage;
